import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private currentRoute: ActivatedRoute | null = null;

  constructor(private router: Router){}

  setCurrentRoute(route: ActivatedRoute | null) {
    this.currentRoute = route;
  }

  getCurrentRoute(): ActivatedRoute | null {
    return this.currentRoute || null;
  }

  navigateWithPagination(): void {
    this.router.navigate(['../'])
  }
}
